<template>
    <div id="taskPlan">
        <p class="log-title">计划任务</p>
        <div class="list-box">
            <header class="tabs-box clearfix">
                <div :class="{'active':state==0}" @click="headClick(0)" id="headClick0"><span>任务执行记录</span></div>
                <div :class="{'active':state==1}" @click="headClick(1)" id="headClick1"><span>任务列表</span></div>
            </header>
            <div class="bg">
                <!-- 维保记录 -->
                <div v-show="state == 0" style="height: 100%;">
                    <div class="clearfix" style="height: 100%;">
                        <ul class="list-title" style="width: 100%; margin-left: 0;">
                            <li class="w-18">任务名称</li>
                            <li>执行时间</li>
                            <li class="w-60">执行结果</li>
                        </ul>
                        <div class="scroll w-100" style="margin-top:0 !important;">
                            <ul class="list-details" v-for="(item,i) in recordList" :key="i">
                                <li :title="item.name" class="w-18">{{item.name}}</li>
                                <li :title="changeTime(item.createdTime)">{{changeTime(item.createdTime)}}</li>
                                <li :title="item.message" class="w-60">{{item.message}}</li>
                            </ul>
                        </div>
                        <div style=" margin-top: 32px;" ><Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber" v-show="state==0"></Pagination></div>
                        <!-- 没有列表数据 -->
                        <div class="nullDataBox" v-show="recordList.length==0">
                            <img :src="nullData" class="nullData">
                            <span>什么东西都没有找到...</span>
                        </div>
                    </div>
                </div>
                <!-- 计划列表 -->
                <div v-show="state == 1" style="height: 95%;">
                    <header class="clearfix top-20 w-97">
                        <el-button type="primary" class="add-btn" @click="addTask" :disabled="!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook">新建计划任务</el-button>
                        <div class="search-box f-r">
                            <div class="select-box f-l">
                                <span>关联设备：</span>
                                <el-select v-model="deviceId" placeholder="请选择">
                                  <el-option
                                  label="全部"
                                  :value="null">
                                  </el-option>
                                  <el-option
                                  v-for="devObj in deviceList"
                                  :key="devObj.id"
                                  :label="devObj.name"
                                  :value="devObj.id">
                                  </el-option>
                                </el-select>
                                <div class="search w-386 f-l">
                                    <el-input
                                        placeholder="请输入任务名称或关联设备名称"
                                        v-model="keyword" class="search-input" @keyup.enter.native="getTaskList">
                                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                                    </el-input>
                                </div>
                            </div>
                            <div class="f-r">
                                <div class="w-76 f-r">
                                    <el-button type="primary" class="add-btn" @click="getTaskList">搜索</el-button>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div class="clearfix m-t-38" style="height: 90%;">
                        <ul class="list-title" style="width: 100%; margin-left: 0;">
                            <li class="w-28">任务名称</li>
                            <li>任务状态</li>
                            <li class="w-18">关联设备</li>
                            <li class="w-28">备注</li>
                            <li class="operate w-18">操作</li>
                            <li class="w-18"></li>
                            <li class="w-18"></li>
                        </ul>
                        <div class="scroll" v-show="taskList.length!=0">
                            <ul class="list-details" v-for="(item,i) in taskList" :key="i">
                                <li class="w-28" :title="item.name">{{item.name}}</li>
                                <li :class="{'color-red':item.state != 1}">{{item.state==1?"启用":item.state==2?"停用":"已过期"}}</li>
                                <li :title="item.deviceName" class="w-18">{{item.deviceName}}</li>
                                <li :title="item.note" class="w-28">{{item.note}}</li>
                                <li class="operate w-18">
                                    <span @click="open(i,'editTaskShow',item)">{{$store.state.functionList.includes('companyServiceEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}" @click="open(i,'delTaskShow',item)">删除</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceContrl')||$store.state.isLook}" @click="open(i,'disTaskShow',item)" v-show="item.state == 1">停用</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceContrl')||$store.state.isLook}" @click="open(i,'enaTaskShow',item)" v-show="item.state != 1">启用</span>
                                </li>
                                <li class="w-18"></li>
                                <li class="w-18"></li>
                            </ul>
                        </div>
                        <!-- 没有列表数据 -->
                        <div class="nullDataBox" v-show="taskList.length==0">
                            <img :src="nullData" class="nullData">
                            <span>什么东西都没有找到...</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 分页 -->
            <!-- <div style="position: absolute; bottom: 35px; width: 100%;"><Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber" v-show="state==0"></Pagination></div> -->
            <!-- 弹窗 -->
            <div class="popup">
                <!-- 删除任务 -->
                <div class="popup-delTesk" v-show="delTaskShow">
                    <div class="popup-title">
                        删除任务<i class="el-icon-circle-close close" @click="close('delTaskShow')" id="closeDel1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将删除该任务"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" id="delTask" @click="delTask">确定</el-button> <el-button @click="close('delTaskShow')" id="closeDel2">取消</el-button></p>
                    </div>
                </div>
                 <!-- 停用任务 -->
                 <div class="popup-delTesk" v-show="disTaskShow">
                    <div class="popup-title">
                        停用任务<i class="el-icon-circle-close close" @click="close('disTaskShow')" id="closeDis1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将停用该任务"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" id="disTask" @click="disTask">确定</el-button> <el-button @click="close('disTaskShow')" id="closeDis2">取消</el-button></p>
                    </div>
                </div>
                 <!-- 启用任务 -->
                 <div class="popup-delTesk" v-show="enaTaskShow">
                    <div class="popup-title">
                        启用任务<i class="el-icon-circle-close close" @click="close('enaTaskShow')" id="closeEna1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将启用该任务"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" id="enaTask" @click="enaTask">确定</el-button> <el-button @click="close('enaTaskShow')" id="closeEna2">取消</el-button></p>
                    </div>
                </div>
                <!-- 新建任务 -->
                <div class="popup-addTesk" v-show="addTaskShow">
                    <div class="popup-title">
                        新建计划任务<i class="el-icon-circle-close close" @click="close('addTaskShow')" id="closeDel1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        <el-form :model='ruleForm' :rules="rules" ref="addTask" class="clearfix">
                            <el-form-item prop="name" label="任务名称：" autocomplete="off" class="no-title">
                                <i><img :src="notes" title="任务名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.name"></el-input>
                            </el-form-item>
                            <el-form-item prop="TimeType" label="执行时间：" autocomplete="off" class="no-title">
                                <el-radio-group v-model="ruleForm.TimeType" class="m-l-12">
                                    <el-radio :label="1">指定时间</el-radio>
                                    <el-radio :label="2">特定时间</el-radio>
                                    <!-- <el-radio :label="3">任意时间</el-radio> -->
                                </el-radio-group>
                                <div v-show="ruleForm.TimeType == 2" style="height: 24px;">
                                    <el-checkbox-group v-model="ruleForm.weekList" class="weekList">
                                        <el-checkbox :label="2">周一</el-checkbox>
                                        <el-checkbox :label="3">周二</el-checkbox>
                                        <el-checkbox :label="4">周三</el-checkbox>
                                        <el-checkbox :label="5">周四</el-checkbox>
                                        <el-checkbox :label="6">周五</el-checkbox>
                                        <el-checkbox :label="7">周六</el-checkbox>
                                        <el-checkbox :label="1">周日</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div v-show='ruleForm.TimeType == 1'>
                                    <el-date-picker
                                        v-model="ruleForm.assignDate"
                                        type="datetime"
                                        class="w-100 assignDate"
                                        placeholder="选择日期"
                                        :clearable='false'
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :editable='false'
                                        id="addAssignDate"
                                        :picker-options="pickerOptionsEnd"
                                    >
                                    </el-date-picker>
                                </div>
                            </el-form-item>
                            <p v-show="ruleForm.TimeType == 2" style="margin-top: 22px;">
                                <span>时：</span>
                                <el-select v-model="ruleForm.hour" placeholder="请选择" class="attribute">
                                    <el-option v-for="hour in hourData" :key="hour" :value="hour" :label="hour"></el-option>
                                </el-select>
                                <span>分：</span>
                                <el-select v-model="ruleForm.min" placeholder="请选择" class="attribute">
                                    <el-option v-for="min in MinuteSecond" :key="min" :value="min" :label="min"></el-option>
                                </el-select>
                                <span>秒：</span>
                                <el-select v-model="ruleForm.second" placeholder="请选择" class="attribute">
                                    <el-option v-for="second in MinuteSecond" :key="second" :value="second" :label="second"></el-option>
                                </el-select>
                            </p>
                            <el-form-item label="前置条件：" autocomplete="off" class="no-title w-100">
                                <div class="dev-attr-box w-100">
                                    <el-select v-model="ruleForm.actionCondition.deviceCode" :title="ruleForm.actionCondition.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(ruleForm.actionCondition.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,'actionCondition')">
                                        <el-option
                                        :key="VirtualDevice.id"
                                        label="虚拟设备"
                                        :value="VirtualDevice.code" >
                                        </el-option>
                                        <el-option
                                        v-for="devObj in deviceList"
                                        :key="devObj.id"
                                        :label="devObj.name"
                                        :value="devObj.code">
                                        </el-option>
                                    </el-select>
                                    <el-select v-model="ruleForm.actionCondition.property" :title="getTitle(ruleForm.actionCondition.property,ruleForm.actionCondition.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,'actionCondition')">
                                        <el-option
                                        v-for="attrObj,a in ruleForm.actionCondition.propertyData"
                                        :key="a"
                                        :label="attrObj.name"
                                        :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                        </el-option>
                                    </el-select>
                                    <el-select v-model="ruleForm.actionCondition.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.actionCondition.type == 'int' || ruleForm.actionCondition.type == 'float' || ruleForm.actionCondition.type == 'double'">
                                        <el-option :value=1 label=">"></el-option>
                                        <el-option :value=2 label=">="></el-option>
                                        <el-option :value=3 label="=="></el-option>
                                        <el-option :value=4 label="<"></el-option>
                                        <el-option :value=5 label="<="></el-option>
                                        <el-option :value=6 label="!="></el-option>
                                        <el-option :value=7 label="in"></el-option>
                                        <el-option :value=8 label="between"></el-option>
                                    </el-select>
                                    <el-select v-model="ruleForm.actionCondition.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.actionCondition.type == 'bool' || ruleForm.actionCondition.type == 'enum'">
                                        <el-option :value=3 label="=="></el-option>
                                    </el-select>
                                    <el-input class="attribute f-r m-r-0" placeholder="请输入比较值" @input="regNumber('actionCondition')" v-model="ruleForm.actionCondition.value" v-show="ruleForm.actionCondition.type == 'int' || ruleForm.actionCondition.type == 'float' || ruleForm.actionCondition.type == 'double'"></el-input>
                                    <el-select v-model="ruleForm.actionCondition.value" placeholder="请选择" class="attribute f-r m-r-0" v-show="ruleForm.actionCondition.type == 'bool' || ruleForm.actionCondition.type == 'enum'">
                                        <el-option
                                        v-for="specsObj in ruleForm.actionCondition.propertyData.specs"
                                        :key="specsObj.key"
                                        :label="specsObj.value"
                                        :value="specsObj.key">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                            <el-form-item label="执行动作：" autocomplete="off" class="no-title w-100" prop="action">
                                <div class="dev-attr-box w-100">
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="action.deviceCode" :rules="rules.action_deviceCode">
                                        <el-select v-model="ruleForm.action.deviceCode" :title="getTitle(ruleForm.action.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,'action')">
                                            <el-option
                                            v-for="devObj in deviceList"
                                            :key="devObj.id"
                                            :label="devObj.name"
                                            :value="devObj.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="action.property" :rules="rules.action_property">
                                        <el-select v-model="ruleForm.action.property" :title="getTitle(ruleForm.action.property,ruleForm.action.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,'action')">
                                            <el-option
                                            v-for="attrObj in ruleForm.action.propertyData"
                                            :key="attrObj.identifier"
                                            :label="attrObj.name"
                                            :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="action.value" :rules="rules.action_value">
                                        <el-input class="attribute m-r-0" placeholder="请输入值" @input="regNumber('action')" v-model="ruleForm.action.value" v-show="ruleForm.action.type == 'int' || ruleForm.action.type == 'float' || ruleForm.action.type == 'double'"></el-input>
                                        <el-select v-model="ruleForm.action.value" placeholder="请选择" class="attribute m-r-0" v-show="ruleForm.action.type == 'bool' || ruleForm.action.type == 'enum'">
                                            <el-option
                                            v-for="specsObj in ruleForm.action.propertyData.specs"
                                            :key="specsObj.key"
                                            :label="specsObj.value"
                                            :value="specsObj.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="验证条件：" autocomplete="off" class="no-title w-100" prop="action">
                                <div class="dev-attr-box w-100">
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="verifyCondition.deviceCode" :rules="rules.verifyCondition_deviceCode">
                                        <el-select v-model="ruleForm.verifyCondition.deviceCode"  :title="ruleForm.verifyCondition.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(ruleForm.verifyCondition.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,'verifyCondition')">
                                            <el-option
                                            :key="VirtualDevice.id"
                                            label="虚拟设备"
                                            :value="VirtualDevice.code">
                                            </el-option>
                                            <el-option
                                            v-for="devObj in deviceList"
                                            :key="devObj.id"
                                            :label="devObj.name"
                                            :value="devObj.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="verifyCondition.property" :rules="rules.verifyCondition_property">
                                        <el-select v-model="ruleForm.verifyCondition.property" :title="getTitle(ruleForm.verifyCondition.property,ruleForm.verifyCondition.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,'verifyCondition')">
                                            <el-option
                                            v-for="attrObj in ruleForm.verifyCondition.propertyData"
                                            :key="attrObj.identifier"
                                            :label="attrObj.name"
                                            :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="verifyCondition.compare" :rules="rules.verifyCondition_compare">
                                        <el-select v-model="ruleForm.verifyCondition.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.verifyCondition.type == 'int' || ruleForm.verifyCondition.type == 'float' || ruleForm.verifyCondition.type == 'double'">
                                            <el-option :value=1 label=">"></el-option>
                                            <el-option :value=2 label=">="></el-option>
                                            <el-option :value=3 label="=="></el-option>
                                            <el-option :value=4 label="<"></el-option>
                                            <el-option :value=5 label="<="></el-option>
                                            <el-option :value=6 label="!="></el-option>
                                            <el-option :value=7 label="in"></el-option>
                                            <el-option :value=8 label="between"></el-option>
                                        </el-select>
                                        <el-select v-model="ruleForm.verifyCondition.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.verifyCondition.type == 'bool' || ruleForm.verifyCondition.type == 'enum'">
                                            <el-option :value=3 label="=="></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28 m-l-6" prop="verifyCondition.value" :rules="rules.verifyCondition_value">
                                        <el-input class="attribute f-r m-r-0" placeholder="请输入比较值" @input="regNumber('verifyCondition')" v-model="ruleForm.verifyCondition.value" v-show="ruleForm.verifyCondition.type == 'int' || ruleForm.verifyCondition.type == 'float' || ruleForm.verifyCondition.type == 'double'"></el-input>
                                        <el-select v-model="ruleForm.verifyCondition.value" placeholder="请选择" class="attribute f-r m-r-0" v-show="ruleForm.verifyCondition.type == 'bool' || ruleForm.verifyCondition.type == 'enum'">
                                            <el-option
                                            v-for="specsObj in ruleForm.verifyCondition.propertyData.specs"
                                            :key="specsObj.key"
                                            :label="specsObj.value"
                                            :value="specsObj.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="256"
                                    show-word-limit
                                    id="addRemarks"
                                    placeholder="请输入描述">
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <p class="btn-box b-32"><el-button type="primary" @click="createdPlan">确定</el-button> <el-button @click="close('addTaskShow')">取消</el-button></p>
                </div>
                <!-- 编辑任务 -->
                <div class="popup-addTesk" v-show="editTaskShow">
                    <div class="popup-title">
                        {{$store.state.functionList.includes('companyServiceEdit')&&!$store.state.isLook?'编辑':'查看'}}计划任务<i class="el-icon-circle-close close" @click="close('editTaskShow')" id="closeDel1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        <el-form :model='ruleForm' :rules="rules" ref="editTask" class="clearfix" :disabled="!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook">
                            <el-form-item prop="name" label="任务名称：" autocomplete="off" class="no-title">
                                <i><img :src="notes" title="任务名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.name"></el-input>
                            </el-form-item>
                            <el-form-item prop="TimeType" label="执行时间：" autocomplete="off" class="no-title">
                                <el-radio-group v-model="ruleForm.TimeType" class="m-l-12">
                                    <el-radio :label="1">指定时间</el-radio>
                                    <el-radio :label="2">特定时间</el-radio>
                                    <el-radio :label="3">任意时间</el-radio>
                                </el-radio-group>
                                <div v-show="ruleForm.TimeType == 2" style="height: 24px;">
                                    <el-checkbox-group v-model="ruleForm.weekList" class="weekList">
                                        <el-checkbox :label="2">周一</el-checkbox>
                                        <el-checkbox :label="3">周二</el-checkbox>
                                        <el-checkbox :label="4">周三</el-checkbox>
                                        <el-checkbox :label="5">周四</el-checkbox>
                                        <el-checkbox :label="6">周五</el-checkbox>
                                        <el-checkbox :label="7">周六</el-checkbox>
                                        <el-checkbox :label="1">周日</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div v-show='ruleForm.TimeType == 1'>
                                    <el-date-picker
                                        v-model="ruleForm.assignDate"
                                        type="datetime"
                                        class="w-100 assignDate"
                                        placeholder="选择日期"
                                        :clearable='false'
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :editable='false'
                                        id="editAssignDate"
                                        :picker-options="pickerOptionsEnd"
                                    >
                                    </el-date-picker>
                                </div>
                            </el-form-item>
                            <p v-show="ruleForm.TimeType == 2" style="margin-top: 22px;">
                                <span>时：</span>
                                <el-select v-model="ruleForm.hour" placeholder="请选择" class="attribute">
                                    <el-option v-for="hour in hourData" :key="hour" :value="hour" :label="hour"></el-option>
                                </el-select>
                                <span>分：</span>
                                <el-select v-model="ruleForm.min" placeholder="请选择" class="attribute">
                                    <el-option v-for="min in MinuteSecond" :key="min" :value="min" :label="min"></el-option>
                                </el-select>
                                <span>秒：</span>
                                <el-select v-model="ruleForm.second" placeholder="请选择" class="attribute">
                                    <el-option v-for="second in MinuteSecond" :key="second" :value="second" :label="second"></el-option>
                                </el-select>
                            </p>
                            <el-form-item label="前置条件：" autocomplete="off" class="no-title w-100">
                                <div class="dev-attr-box w-100">
                                    <el-select v-model="ruleForm.actionCondition.deviceCode" :title="ruleForm.actionCondition.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(ruleForm.actionCondition.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,'actionCondition')">
                                        <el-option
                                        :key="VirtualDevice.id"
                                        label="虚拟设备"
                                        :value="VirtualDevice.code" >
                                        </el-option>
                                        <el-option
                                        v-for="devObj in deviceList"
                                        :key="devObj.code"
                                        :label="devObj.name"
                                        :value="devObj.code">
                                        </el-option>
                                    </el-select>
                                    <el-select v-model="ruleForm.actionCondition.property" :title="getTitle(ruleForm.actionCondition.property,ruleForm.actionCondition.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,'actionCondition')">
                                        <el-option
                                        v-for="attrObj,a in ruleForm.actionCondition.propertyData"
                                        :key="a"
                                        :label="attrObj.name"
                                        :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                        </el-option>
                                    </el-select>
                                    <el-select v-model="ruleForm.actionCondition.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.actionCondition.type == 'int' || ruleForm.actionCondition.type == 'float' || ruleForm.actionCondition.type == 'double'">
                                        <el-option :value=1 label=">"></el-option>
                                        <el-option :value=2 label=">="></el-option>
                                        <el-option :value=3 label="=="></el-option>
                                        <el-option :value=4 label="<"></el-option>
                                        <el-option :value=5 label="<="></el-option>
                                        <el-option :value=6 label="!="></el-option>
                                        <el-option :value=7 label="in"></el-option>
                                        <el-option :value=8 label="between"></el-option>
                                    </el-select>
                                    <el-select v-model="ruleForm.actionCondition.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.actionCondition.type == 'bool' || ruleForm.actionCondition.type == 'enum'">
                                        <el-option :value=3 label="=="></el-option>
                                    </el-select>
                                    <el-input class="attribute f-r m-r-0" placeholder="请输入比较值" @input="regNumber('actionCondition')" v-model="ruleForm.actionCondition.value" v-show="ruleForm.actionCondition.type == 'int' || ruleForm.actionCondition.type == 'float' || ruleForm.actionCondition.type == 'double'"></el-input>
                                    <el-select v-model="ruleForm.actionCondition.value" placeholder="请选择" class="attribute f-r m-r-0" v-show="ruleForm.actionCondition.type == 'bool' || ruleForm.actionCondition.type == 'enum'">
                                        <el-option
                                        v-for="specsObj in ruleForm.actionCondition.propertyData.specs"
                                        :key="specsObj.key"
                                        :label="specsObj.value"
                                        :value="specsObj.key">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                            <el-form-item label="执行动作：" autocomplete="off" class="no-title w-100" prop="action">
                                <div class="dev-attr-box w-100">
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="action.deviceCode" :rules="rules.action_deviceCode">
                                        <el-select v-model="ruleForm.action.deviceCode" :title="getTitle(ruleForm.action.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,'action')">
                                            <el-option
                                            v-for="devObj in deviceList"
                                            :key="devObj.id"
                                            :label="devObj.name"
                                            :value="devObj.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="action.property" :rules="rules.action_property">
                                        <el-select v-model="ruleForm.action.property" :title="getTitle(ruleForm.action.property,ruleForm.action.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,'action')">
                                            <el-option
                                            v-for="attrObj in ruleForm.action.propertyData"
                                            :key="attrObj.identifier"
                                            :label="attrObj.name"
                                            :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="action.value" :rules="rules.action_value">
                                        <el-input class="attribute m-r-0" placeholder="请输入值" @input="regNumber('action')" v-model="ruleForm.action.value" v-show="ruleForm.action.type == 'int' || ruleForm.action.type == 'float' || ruleForm.action.type == 'double'"></el-input>
                                        <el-select v-model="ruleForm.action.value" placeholder="请选择" class="attribute m-r-0" v-show="ruleForm.action.type == 'bool' || ruleForm.action.type == 'enum'">
                                            <el-option
                                            v-for="specsObj in ruleForm.action.propertyData.specs"
                                            :key="specsObj.key"
                                            :label="specsObj.value"
                                            :value="specsObj.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="验证条件：" autocomplete="off" class="no-title w-100" prop="action">
                                <div class="dev-attr-box w-100">
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="verifyCondition.deviceCode" :rules="rules.verifyCondition_deviceCode">
                                        <el-select v-model="ruleForm.verifyCondition.deviceCode"  :title="ruleForm.verifyCondition.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(ruleForm.verifyCondition.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,'verifyCondition')">
                                            <el-option
                                            :key="VirtualDevice.id"
                                            label="虚拟设备"
                                            :value="VirtualDevice.code">
                                            </el-option>
                                            <el-option
                                            v-for="devObj in deviceList"
                                            :key="devObj.id"
                                            :label="devObj.name"
                                            :value="devObj.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="verifyCondition.property" :rules="rules.verifyCondition_property">
                                        <el-select v-model="ruleForm.verifyCondition.property" :title="getTitle(ruleForm.verifyCondition.property,ruleForm.verifyCondition.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,'verifyCondition')">
                                            <el-option
                                            v-for="attrObj in ruleForm.verifyCondition.propertyData"
                                            :key="attrObj.identifier"
                                            :label="attrObj.name"
                                            :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28" prop="verifyCondition.compare" :rules="rules.verifyCondition_compare">
                                        <el-select v-model="ruleForm.verifyCondition.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.verifyCondition.type == 'int' || ruleForm.verifyCondition.type == 'float' || ruleForm.verifyCondition.type == 'double'">
                                            <el-option :value=1 label=">"></el-option>
                                            <el-option :value=2 label=">="></el-option>
                                            <el-option :value=3 label="=="></el-option>
                                            <el-option :value=4 label="<"></el-option>
                                            <el-option :value=5 label="<="></el-option>
                                            <el-option :value=6 label="!="></el-option>
                                            <el-option :value=7 label="in"></el-option>
                                            <el-option :value=8 label="between"></el-option>
                                        </el-select>
                                        <el-select v-model="ruleForm.verifyCondition.compare" placeholder="请选择" class="attribute w-75" v-show="ruleForm.verifyCondition.type == 'bool' || ruleForm.verifyCondition.type == 'enum'">
                                            <el-option :value=3 label="=="></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" autocomplete="off" class="w-28 m-l-6" prop="verifyCondition.value" :rules="rules.verifyCondition_value">
                                        <el-input class="attribute f-r m-r-0" placeholder="请输入比较值" @input="regNumber('verifyCondition')" v-model="ruleForm.verifyCondition.value" v-show="ruleForm.verifyCondition.type == 'int' || ruleForm.verifyCondition.type == 'float' || ruleForm.verifyCondition.type == 'double'"></el-input>
                                        <el-select v-model="ruleForm.verifyCondition.value" placeholder="请选择" class="attribute f-r m-r-0" v-show="ruleForm.verifyCondition.type == 'bool' || ruleForm.verifyCondition.type == 'enum'">
                                            <el-option
                                            v-for="specsObj in ruleForm.verifyCondition.propertyData.specs"
                                            :key="specsObj.key"
                                            :label="specsObj.value"
                                            :value="specsObj.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="256"
                                    show-word-limit
                                    id="editRemarks"
                                    placeholder="请输入描述">
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <p class="btn-box b-32"><el-button type="primary" @click="updatePlan" :disabled="!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook">确定</el-button> <el-button @click="close('editTaskShow')">取消</el-button></p>
                </div>

                <!-- 验证码授权 -->
                <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -216px; z-index:1000 !important;">
                    <div class="popup-title">
                        获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                    </div>
                    <div class="popup-lab">
                        手机号：
                        <el-input disabled v-model="phone">{{phone}}</el-input>
                    </div>
                    <div class="popup-lab clearfix">
                        <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                        <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                            <el-form-item prop="verifyCode">
                                <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="code-box">
                            <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                        </div>
                    </div>
                    <div class="popup-lab">
                        <p class="btn-box" style="margin-top: 26px;">
                            <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                            <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
export default {
    data() {
        var valiWarnName = (rule, value, callback) =>{  //规则名称
            // value=this.ruleForm.alarmName;
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" ||value==null){
                callback(new Error('请输入任务名称'));
            }else if(value.length>32){
                callback(new Error('任务名称由1~32个字符构成'));
            }else{
                callback();
            }
        }
        var valiTimeType= (rule, value, callback) =>{  //规则名称
            if(this.ruleForm.TimeType==1){
                if(this.ruleForm.assignDate == ""||this.ruleForm.assignDate == null){
                    callback(new Error('请选择指定时间'))
                }else{
                    callback()
                }
            }else{
                if(this.ruleForm.weekList.length == 0){
                    callback(new Error('请选择特定时间:周'))
                }else if(this.ruleForm.hour==""||this.ruleForm.hour==null){
                    callback(new Error('请选择特定时间：时'))
                }else if(this.ruleForm.min==""||this.ruleForm.min==null){
                    callback(new Error('请选择特定时间：分'))
                }else if(this.ruleForm.second==""||this.ruleForm.second==null){
                    callback(new Error('请选择特定时间：秒'))
                }else{
                    callback()
                }
            }
        }
        var valiAction=(rule, value, callback) =>{  //规则名称
            callback()
        }
        return {
            state:0,
            totalCount:0,
            pageSize:0,
            pageNumber:1,
            delTaskShow:false,
            addTaskShow:false,
            editTaskShow:false,
            disTaskShow:false,
            enaTaskShow:false,
            notes:require('@/assets/image/organize/notes.png'),
            nullData:require('@/assets/image/index/nullData.png'),
            recordList:[],
            taskList:[],
            deviceList:[],
            allDev:[],
            // allProductData:[],
            VirtualDevice:{},   //虚拟设备
            VirtualFuncList:[], //虚拟设备属性列表
            nowIndex:null,
            nowObj:{},
            hourData:[],
            MinuteSecond:[],
            radioTime:0,
            deviceId:null,
            keyword:"",
            ruleForm:{
                name:"",
                note:"",
                TimeType:1,
                actionTime:"",
                devIdList:[],
                deviceId:null,
                deviceName:null,
                state:1,
                conditionType:1,
                actionCondition:{       //前置条件
                    deviceCode:null,
                    property:null,
                    compare:null,
                    value:null,
                    type:'int',
                    propertyData:[
                        {dataType:{type:'int'}}
                    ]
                },
                action:{       //执行动作
                    deviceCode:null,
                    property:null,
                    compare:null,
                    value:null,
                    type:'int',
                    propertyData:[
                        {dataType:{type:'int'}}
                    ]
                },
                verifyCondition:{       //验证条件
                    deviceCode:null,
                    property:null,
                    compare:null,
                    value:null,
                    type:'int',
                    propertyData:[
                        {dataType:{type:'int'}}
                    ]
                },
                assignDate:"",
                weekList:[],
                hour:"",
                min:"",
                second:"",
            },
            rules:{
                name:[{required:true,validator:valiWarnName,trigger:"blur"}],
                TimeType:[{required:true,validator:valiTimeType,trigger:"blur"}],
                actionTime:[{required:true,message:"请选择指定时间",trigger:"blur"}],
                action:[{required:true,validator:valiAction,trigger:"blur"}],
                action_deviceCode:[{required:true,message:"请选择设备",trigger:"change"}],
                action_property:[{required:true,message:"请选择属性",trigger:"change"}],
                action_value:[{required:true,message:"值不能为空",trigger:"change"}],
                verifyCondition_deviceCode:[{required:true,message:"请选择设备",trigger:"change"}],
                verifyCondition_property:[{required:true,message:"请选择属性",trigger:"change"}],
                verifyCondition_compare:[{required:true,message:"请选择比较模式",trigger:"change"}],
                verifyCondition_value:[{required:true,message:"值不能为空",trigger:"change"}],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }],
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    return time.getTime() < new Date().getTime() - 86400000
                }
            },
            functionShow:false,
            VerifyArr:[],
            verifyForm:{
                verifyCode:'',
            },
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,
        }
    },
    components:{
        Pagination
    },
    props: {
        companyId:{
            type:Number,
            required:true,
        }
    },
    created() {
        this.$store.state.headerActive=4;
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.getTaskLog({pageNumber:this.pageNumber,length:this.pageSize,companyId:this.companyId})
        this.getdeviceList()
        // this.getProlist()
        this.getVirtualDevice()
        this.changeList()
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
        this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
    },
    methods: {
        // 获取计划任务日志
        getTaskLog(parm){
            this.get('/TaskPlanLog/query',parm).then((res)=>{
                if(res.success){
                    this.recordList = res.result.data
                    this.totalCount = res.result.totalCount;
                }else{
                    this.$message({
                        message: `获取任务日志数据失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 获取计划任务列表
        getTaskList(){
            this.get('/TaskPlan/getList',{companyId:this.companyId,deviceId:this.deviceId,keyword:this.keyword}).then((res)=>{
                if(res.success){
                    this.taskList = res.result
                }else{
                    this.$message({
                        message: `获取计划任务列表数据失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 设置时分秒列表
        changeList(){
            for(let i=0;i<24;i++){
                let hour
                if(i<10){
                    hour = "0"+i
                }else{
                    hour = i.toString()
                }
                this.hourData.push(hour)
            }
            for(let i=0;i<60;i++){
                let MS
                if(i<10){
                    MS = "0"+i
                }else{
                    MS = i.toString()
                }
                this.MinuteSecond.push(MS)
            }
        },
        //获取指定企业的虚拟设备
        getVirtualDevice(){
            let parm = {companyId:this.companyId}
            this.get('/VirtualDevice/get',parm).then((res)=>{
                if(res.success){
                    this.VirtualDevice = res.result
					this.getVirtualFuncList()
                }
            })
        },
        //获取虚拟设备的属性列表
        getVirtualFuncList(){
            let parm = {deviceId:this.VirtualDevice.id,companyId:this.companyId}
            this.get('/VirtualDevice/getPropertyList',parm).then((res)=>{
                if(res.success){
                    for(let obj of res.result){
                        obj.dataType={type:'double',specs:[]}
                        obj.identifier = obj.code
                    }
                    this.VirtualFuncList = res.result
                }
            })
        },
        //获取所有产品
        // getProlist(){
        //     this.get('/Product/getList',{companyId:this.companyId}).then((res)=>{
        //         if(res.success){
        //             this.allProductData=res.result;
        //         }else{
        //             this.$message({
        //                 message: `获取产品数据失败:${res.message}`,
        //                 type: 'warning'
        //             });
        //         }
        //     })
        // },
        //获取设备列表
        getdeviceList(){
            let parm = {companyId:this.companyId}
            this.get('/Device/getList',parm).then((res)=>{
                if(res.success){
                    this.deviceList = res.result
                    for(let dev of this.deviceList){
                        //将所有设备的id取出
                        this.allDev.push(dev.id)
                    }
                }
            })
        },
        // 头部点击
        headClick(i){
            this.state = i
            if(i == 0){
                this.getTaskLog({pageNumber:this.pageNumber,length:this.pageSize,companyId:this.companyId})
            }else{
                this.getTaskList()
            }
        },
        // 修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            this.getTaskLog({pageNumber:this.pageNumber,length:this.pageSize,companyId:this.companyId})
        },
        // 修改页数
        setNum(number){
            this.pageNumber=number;
            this.getTaskLog({pageNumber:this.pageNumber,length:this.pageSize,companyId:this.companyId})
        },
        //设备变更时更新对应属性值
        changeDev(code,name,val){
            let attrData = null
            if(val){
                this.ruleForm[name].property = val;
            }else{
                this.ruleForm[name].property = null;
            }
            if(code==this.VirtualDevice.code){
                this.ruleForm[name].propertyData = this.VirtualFuncList
                if(name == 'action'){
                    this.ruleForm.deviceCode = code;
                    this.ruleForm.deviceName = '虚拟设备';
                }
                this.changeAttr(val,name)
            }else{
                for(let devObj of this.deviceList){
                    if(devObj.code == code){
                        this.get('/ProductFeature/getByDeviceCode',{code:devObj.code}).then((res)=>{
                            if(res.success){
                                let attrData=JSON.parse(res.result).properties   //属性数组
                                let propertyArr = devObj.propertySet.split(',')  //设备关联属性数组
                                let arr = []
                                for(let attrObj of attrData){
                                    for(let property of propertyArr){
                                        if(property==attrObj.identifier){
                                            arr.push(attrObj)
                                        }
                                    }
                                }
                                this.ruleForm[name].propertyData = arr
                                if(name == 'action'){
                                    this.ruleForm.deviceId = devObj.id;
                                    this.ruleForm.deviceName = devObj.name;
                                }
                            }else{
                                this.$message({
                                    type:'warning',
                                    message:`获取设备属性失败：${res.message}`
                                })
                            }
                        }).then(()=>{
                            this.changeAttr(val,name,true)
                        })
                    }
                }
            }
        },
        //设备属性变更时改变对应比较值
        changeAttr(val,name,reset){
            if(reset){}else{
                this.ruleForm[name].compare=null;
                this.ruleForm[name].value=null;
            }
            for(var obj of this.ruleForm[name].propertyData){
                if(val == obj.identifier){
                    this.ruleForm[name].type=obj.dataType.type
                    if(obj.dataType.type=="bool"||obj.dataType.type=="enum"){
                        let arr = [];
                        var that = this;
                        Object.keys(obj.dataType.specs).forEach(function(key){
                            let item ={};
                            item.key = key;
                            item.value = obj.dataType.specs[key]
                            arr.push(item);
                        });
                        that.ruleForm[name].propertyData.specs=arr;
                    }
                }
            }
        },
        regNumber(name){
            if(this.ruleForm[name].compare==7||this.ruleForm[name].compare==8){
                this.ruleForm[name].value = '['+this.ruleForm[name].value.replace(/[^\-?\d.,]/g,"").replace(/\[/g, "").replace(/\]/g, "").replace(/,,/g, ",")+']';
            }else{
                this.ruleForm[name].value = this.ruleForm[name].value.replace(/[^\-?\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g,"");
            }
        },
        // 打开弹窗
        open(i,name,obj){
            if(name!='editTaskShow'&&!this.$store.state.functionList.includes('companyServiceEdit')||name!='editTaskShow'&&this.$store.state.isLook){
                return
            }else if((name=='disTaskShow'||name=='enaTaskShow')&&!this.$store.state.functionList.includes('companyServiceContrl')){
              return
            }
            if((name=='disTaskShow'||name=='enaTaskShow')&&this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceContrl')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            this.ruleForm=this.$options.data().ruleForm
            this.nowIndex= i;
            this.nowObj = obj
            if(name == "editTaskShow"){
                let parm = { id:obj.id,companyId:this.companyId}
                this.get('/TaskPlan/get',parm).then((res)=>{
                    if(res.success){
                        let data=res.result
                        this.nowObj = this.clone(data);
                        this.ruleForm.name=data.name;
                        this.ruleForm.note=data.note;
                        this.ruleForm.TimeType=data.time.type;
                        if(this.ruleForm.TimeType==1){
                            this.ruleForm.assignDate = this.changeTime(Number(data.time.date))
                        }else{
                            this.ruleForm.weekList =  data.time.week;
                            let time = data.time.time;
                            let h=Math.floor(time/3600);
                            let m=Math.floor((time - h*3600)/60);
                            let s=time - h*3600 - m*60
                            if(h<10){
                                h="0"+h
                            }else{
                                h=h.toString()
                            }
                            if(m<10){
                                m="0"+m
                            }else{
                                m=m.toString()
                            }
                            if(s<10){
                                s="0"+s
                            }else{
                                s=s.toString()
                            }
                            this.ruleForm.hour = h
                            this.ruleForm.min = m
                            this.ruleForm.second = s
                        }
                        this.ruleForm.actionCondition.deviceCode=data.actionCondition.deviceCode
                        this.changeDev(data.actionCondition.deviceCode,'actionCondition',data.actionCondition.property)
                        // this.changeAttr(data.actionCondition.property,'actionCondition')
                        this.ruleForm.action.deviceCode=data.action.deviceCode
                        this.changeDev(data.action.deviceCode,'action',data.action.property)
                        // this.changeAttr(data.action.property,'action')
                        this.ruleForm.verifyCondition.deviceCode=data.verifyCondition.deviceCode
                        this.changeDev(data.verifyCondition.deviceCode,'verifyCondition',data.verifyCondition.property)
                        // this.changeAttr(data.verifyCondition.property,'verifyCondition')
                        this.ruleForm.actionCondition.property=data.actionCondition.property
                        this.ruleForm.actionCondition.compare=data.actionCondition.compare
                        this.ruleForm.actionCondition.value=data.actionCondition.value
                        this.ruleForm.action.property=data.action.property
                        this.ruleForm.action.compare=data.action.compare
                        this.ruleForm.action.value=data.action.value
                        this.ruleForm.verifyCondition.property=data.verifyCondition.property
                        this.ruleForm.verifyCondition.compare=data.verifyCondition.compare
                        this.ruleForm.verifyCondition.value=data.verifyCondition.value
                        this[name]=true;
                        this.$store.state.mask=true;
                    }else{
                        this.$message({
                            message: `获取计划任务详情失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                })
            }else{
                this[name]=true;
                this.$store.state.mask=true;
            }
        },
        // 关闭弹窗
        close(name){
            this.ruleForm = this.$options.data().ruleForm
            this.$store.state.mask=false;
            this[name]=false;
        },
        // 删除计划任务
        delTask(){
            let parm = {id:this.nowObj.id,companyId:this.companyId}
            this.get('/TaskPlan/remove',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除计划任务成功',
                        type: 'success'
                    });
                    this.getTaskList()
                }else{
                    this.$message({
                        message: `删除计划任务失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.delTaskShow=false
            })
        },
        // 启用计划任务
        enaTask(){
            let parm = {id:this.nowObj.id,companyId:this.companyId}
            this.get('/TaskPlan/enable',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '启用计划任务成功',
                        type: 'success'
                    });
                    this.taskList[this.nowIndex].state=1;
                }else{
                    this.$message({
                        message: `启用计划任务失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.enaTaskShow=false
            })
        },
        // 停用计划任务
        disTask(){
            let parm = {id:this.nowObj.id,companyId:this.companyId}
            this.get('/TaskPlan/disable',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '停用计划任务成功',
                        type: 'success'
                    });
                    this.taskList[this.nowIndex].state=2;
                }else{
                    this.$message({
                        message: `停用计划任务失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.disTaskShow=false
            })
        },
        // 新建计划任务
        createdPlan(){
            this.$refs.addTask.validate((valid) => {
                if(valid){
                    let parm = {
                        companyId:this.companyId,
                        requestId:1,
                        name:this.ruleForm.name,
                        deviceId:this.ruleForm.deviceId,
                        deviceName:this.ruleForm.deviceName,
                        time:{},
                        actionCondition:{
                            deviceCode:this.ruleForm.actionCondition.deviceCode,
                            property:this.ruleForm.actionCondition.property,
                            compare:this.ruleForm.actionCondition.compare,
                            value:this.ruleForm.actionCondition.value,
                        },
                        action:{
                            deviceCode:this.ruleForm.action.deviceCode,
                            property:this.ruleForm.action.property,
                            value:this.ruleForm.action.value,
                        },
                        verifyCondition:{
                            deviceCode:this.ruleForm.verifyCondition.deviceCode,
                            property:this.ruleForm.verifyCondition.property,
                            compare:this.ruleForm.verifyCondition.compare,
                            value:this.ruleForm.verifyCondition.value,
                        },
                        note:this.ruleForm.note
                    }
                    if(this.ruleForm.TimeType == 1){
                        parm.time={
                            type:1,
                            date:new Date(this.ruleForm.assignDate).getTime()
                        }
                    }else{
                        parm.time={
                            type:2,
                            time:Number(this.ruleForm.hour*3600+this.ruleForm.min*60+Number(this.ruleForm.second)),
                            week:this.ruleForm.weekList.sort()
                        }
                    }
                    this.postNoJson('/TaskPlan/create',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '新建计划任务成功',
                                type: 'success'
                            });
                            let parm={
                                id:res.result,
                                companyId:this.companyId,
                                requestId:1
                            }
                            this.get('/TaskPlan/get',parm).then((res)=>{
                                if(res.success){
                                    this.taskList.push(res.result)
                                }
                            })
                            this.addTaskShow = false;
                            this.$store.state.mask = false;
                            this.ruleForm = this.$options.data().ruleForm
                        }else{
                            this.$message({
                                message: `新建计划任务失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        // 编辑计划任务
        updatePlan(){
            this.$refs.editTask.validate((valid) => {
                if(valid){
                    let parm = {
                        id:this.nowObj.id,
                        companyId:this.companyId,
                        requestId:1,
                        name:this.ruleForm.name,
                        deviceId:this.ruleForm.deviceId,
                        deviceName:this.ruleForm.deviceName,
                        time:{},
                        actionCondition:{
                            deviceCode:this.ruleForm.actionCondition.deviceCode,
                            property:this.ruleForm.actionCondition.property,
                            compare:this.ruleForm.actionCondition.compare,
                            value:this.ruleForm.actionCondition.value,
                        },
                        action:{
                            deviceCode:this.ruleForm.action.deviceCode,
                            property:this.ruleForm.action.property,
                            value:this.ruleForm.action.value,
                        },
                        verifyCondition:{
                            deviceCode:this.ruleForm.verifyCondition.deviceCode,
                            property:this.ruleForm.verifyCondition.property,
                            compare:this.ruleForm.verifyCondition.compare,
                            value:this.ruleForm.verifyCondition.value,
                        },
                        note:this.ruleForm.note
                    }
                    if(this.ruleForm.TimeType == 1){
                        parm.time={
                            type:1,
                            date:new Date(this.ruleForm.assignDate).getTime()
                        }
                    }else{
                        parm.time={
                            type:2,
                            time:Number(this.ruleForm.hour*3600+this.ruleForm.min*60+Number(this.ruleForm.second)),
                            week:this.ruleForm.weekList.sort()
                        }
                    }
                    this.postNoJson('/TaskPlan/update',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '编辑计划任务成功',
                                type: 'success'
                            });
                            let data={
                                id:this.nowObj.id,
                                companyId:this.companyId,
                                requestId:1
                            }
                            this.get('/TaskPlan/get',data).then((res)=>{
                                if(res.success){
                                    this.taskList[this.nowIndex]=res.result
                                    this.$forceUpdate()
                                }
                            })
                        }else{
                            this.$message({
                                message: `编辑计划任务失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                        this.editTaskShow = false;
                        this.$store.state.mask = false;
                    })
                }
            })
        },
        // 新增计划任务
        addTask(){
            this.addTaskShow = true;
            this.$store.state.mask=true
            this.$refs.addTask.clearValidate()
        },
        // 下拉框title
        getTitle(val,data,code){
            if(val&&data&&code){
                let result=data.filter(ele => ele[code] == val);
                if (result.length!=0) return result[0].name
            }
        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                  this.$message({
                    message: `${res.message}`,
                    type: 'warning'
                  });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(12),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.functionShow=false
                            this.$store.state.mask=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
    },
}
</script>
<style scoped>
    .list-box{
        position: absolute;
        top: 98px;
        left: 16px;
        right: 16px;
        bottom: 0;
        min-width: 1350px;
        /* min-height: 748px; */
        width: calc(100% - 40px);
    }
    /* 头部标签 */
    .tabs-box{
        position: absolute;
        top: -40px;
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        float: left;
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    /* 背景盒子 */
    .bg{
        background-color: #fff;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right:0;
        padding: 34px 20px 0 20px;
    }
    /* 列表 */
    .scroll{
        overflow: auto;
        max-height: 83% !important;
        height: 83% !important;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        line-height: 44px;
        font-size: 14px;
    }
    .scroll>ul:last-child{
        /* border-bottom: 0; */
    }
    .list-title,.list-details{
        display: flex;
        justify-content: flex-start;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 140px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .w-28{
        width: 28% !important;
    }
    .w-60{
        width: 60% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
        margin-bottom: 18px;
    }
    .m-t-38{
        margin-top: 38px;
    }
    .top-20{
        position: absolute;
        top: 20px;
    }
    /* 弹窗 */
    .popup>div{
        position: fixed;
        top: 7%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-289px;
        width: 578px;
        background-color: #fff;
        z-index: 999;
        padding-bottom: 30px;
        height: 285px;
        text-align: left;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 12px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 8px;
        top: 4px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    .btn-box{
        position: absolute;
        text-align: center;
        bottom: 36px;
        width: 100%;
        left: 0;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .popup-addTesk{
        height: 752px !important;
        top: -98px !important;
        width: 600px !important;
        margin-left: -300px !important;
    }
    .popup-lab-top{
        font-size: 14px;

    }
    .m-l-12{
        margin-left: 12px;
    }
    .attribute{
        width: 127px;
        margin-right: 6px;
    }
    .w-100{
        margin:6px 0 0 0!important;
        width: 100% !important;
    }
    .dev-attr-box{
        padding-top: 32px;
    }
    .w-97{
      width: 97%;
    }
    .search-box{
        text-align: left;
        font-size: 15px;
        float: right;
    }
    .time{
        margin-left: 12px;
        width: 220px;
        margin-right: 25px
    }
    .search{
        float: right;
        width: 75%;
        max-width: 388px;
        min-width: 160px;
        margin-right: 10px;
        margin-left: 20px;
    }
    .w-76{
        width: 76%;
        margin-right: 11px;
    }
    .w-386{
        width: 386px;
    }
</style>
<style>
    #taskPlan .enum .el-form-item__label,#taskPlan .bool .el-form-item__label,#taskPlan .range .el-form-item__label,#taskPlan .w-100 .el-form-item__label{
        width: 100%;
        text-align: left;
    }
    #taskPlan .range .el-input{
        width: 242px;
    }
    #taskPlan .enum .el-input{
        width: 210px;
    }
    #taskPlan .bool .el-input{
        width:482px;
        float: right;
    }
    #taskPlan .popup .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #taskPlan .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #taskPlan .popup .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #taskPlan .popup .el-form-item__content{
        line-height: 34px !important;
    }
    #taskPlan .search .el-icon-search{
        line-height: 34px !important;
    }
    #taskPlan .select-box .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }

    #taskPlan .select-box .el-input__icon{
        line-height: 34px !important;
    }
    #taskPlan .popup .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #taskPlan .remarks textarea{
        width: 100% !important;
        height: 76px !important;
        border: 1px solid #dedede !important;
        resize: none !important;
        padding:5px !important;
        box-sizing: border-box  !important;
        line-height: 20px !important;
        overflow: hidden !important;
    }
    #taskPlan .attribute .el-input__icon,#taskPlan .popup .el-input__icon{
        line-height: 34px !important;
    }
    .enum .el-form-item__error{
        padding-top: 0 !important;
    }
    #taskPlan .checkbox-box .el-checkbox{
        width: 27% !important;
    }
    #taskPlan  .option-scorll-box .el-checkbox{
        display: block;
        text-align: left;
        padding-left: 10px;
        margin-right: 0;
        border-bottom: 1px solid #e6e6e6;
    }
    #taskPlan  .option-scorll-box .el-checkbox__input{
        position: absolute;
        left: 448px;
        top: 15px;
    }
    #taskPlan .assignDate .el-input__prefix{
        position: absolute;
        left: 510px;
    }
    #taskPlan .weekList .el-checkbox{
        margin-right: 25px;
    }
    #taskPlan .popup .el-form-item.w-28{
        float: left;
        width: 127px !important;
        margin-right: 10px;
    }
    #taskPlan .popup .el-form-item.w-28.m-l-6{
        margin-right: 0;
        margin-left: 6px;
    }

</style>



// WEBPACK FOOTER //
// src/components/CompanyConsole/TaskPlan/taskPlan.vue